// @flow

import React, { type AbstractComponent, type Node, useContext } from 'react';
import _HeaderHeight, {
  type HeaderContextType,
} from 'app/common/react/components/Header/Context/Context';

export const HeaderHeightContext = _HeaderHeight;

// HOC
export function withHeaderHeight<Config: {}>(
  Subject: AbstractComponent<Config>,
): AbstractComponent<{ ...Config, headerHeight: HeaderContextType }> {
  return (props) => {
    const headerHeight = useContext(HeaderHeightContext);

    return <Subject {...props} headerHeight={headerHeight} />;
  };
}

// Render Prop
export function HeaderHeight({ children }: { children: (HeaderContextType) => Node }) {
  const headerHeight = useContext(HeaderHeightContext);

  return children(headerHeight);
}

// Hook
export function useHeaderHeight() {
  return useContext(HeaderHeightContext);
}
